import { ComponentProps } from 'react'
import { InputSelectControlField, Link } from '@sequencehq/core-components'

export type UsageCalculationPeriodDropdownValue =
  | 'BILLING_PERIOD'
  | 'CUMULATIVE_USAGE'
  | 'QUARTERLY'
  | 'HALF_YEARLY'
  | 'ANNUAL'
  | 'MONTHLY'

type Props = Pick<
  ComponentProps<typeof InputSelectControlField>,
  'validationErrors'
> & {
  isDisabled?: boolean
  options: { label: string; value: UsageCalculationPeriodDropdownValue }[]
  value: UsageCalculationPeriodDropdownValue
  onChange: (value: UsageCalculationPeriodDropdownValue) => void
}

const desriptionByValue: Record<UsageCalculationPeriodDropdownValue, string> = {
  BILLING_PERIOD: 'Calculate usage for each billing period.',
  CUMULATIVE_USAGE:
    'Tiers in each billing period are based on all prior usage in the schedule.',
  MONTHLY: 'Tiers in each billing period are based on monthly usage.',
  QUARTERLY: 'Tiers in each billing period are based on quarterly usage.',
  HALF_YEARLY: 'Tiers in each billing period are based on semi-annual usage.',
  ANNUAL: 'Tiers in each billing period are based on annual usage.'
}

const UsageCalculationPeriodDropdown = ({
  options,
  value,
  isDisabled,
  onChange,
  ...selectFieldProps
}: Props) => {
  return (
    <InputSelectControlField
      label="Usage calculation period"
      placeholder="Select usage calculation mode"
      options={options}
      value={value}
      disabled={isDisabled}
      onChange={selectedValue =>
        onChange(selectedValue as UsageCalculationPeriodDropdownValue)
      }
      description={
        <>
          {desriptionByValue[value]}{' '}
          <Link
            to="https://docs.sequencehq.com/metrics-events/usage-metrics#usage-calculation-period"
            isExternal
            color="indigo.50"
          >
            Learn more
          </Link>
        </>
      }
      {...selectFieldProps}
    />
  )
}

export default UsageCalculationPeriodDropdown
